import React, { SVGProps } from 'react';

export function MinusIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg width="10" height="3" viewBox="0 0 10 3" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="0.5" y="0.799805" width="9" height="1.4" rx="0.7" fill="currentColor" />
    </svg>
  );
}
